// extracted by mini-css-extract-plugin
module.exports = {"recent_play":"rencentPlay_recent_play__dipEn","menu_item":"rencentPlay_menu_item__6ELXr"};